export default __webpack_public_path__ + "images/Image13.76cbb714.png";